import { QUERY_MOBILE } from '../constants/query-params/mobile';
import serializeQueryParams from './url/serialize-query-params';
import urlContainsParam from './url/url-contains-param';

const isMobileAppWithDeeplinkRedirect = () => {
    return (urlContainsParam(QUERY_MOBILE.APP_WITH_DEEPLINK_REDIRECT) || urlContainsParam(QUERY_MOBILE.MOBILE_APP)) || undefined;
};

export const isMobileAppAndroid = () => {
    const params = serializeQueryParams();

    return Boolean(params[QUERY_MOBILE.IS_ANDROID]) || String(params[QUERY_MOBILE.OS]) === 'android';
};

export default isMobileAppWithDeeplinkRedirect;
